module.exports = __webpack_public_path__ + "static/media/note-white-small.069730c7.svg";